import { utils } from 'utils';

export const ZENDESK_ERROR_MESSAGE =
  'Something wrong with zendesk login. Please try again or contact support';

export const getZendeskRedirectUrlFromSessionStorage = () => {
  return window.sessionStorage.getItem('zendeskRedirectUrl');
};

export const submitZendeskForm = async ({
  accessToken,
  zendeskRedirectUrl,
  formRef,
  inputRef,
}) => {
  try {
    const url = await utils.getZendeskRedirectUrl({
      accessToken,
      zendeskRedirectUrl,
    });

    const formReady = inputRef?.current && formRef?.current;

    if (!formReady) {
      console.error('Zendesk form refs not ready', {
        errorLocation: 'zendeskService.submitZendeskForm',
        inputRefExists: Boolean(inputRef?.current),
        formRefExists: Boolean(formRef?.current),
      });
      return { success: false, error: ZENDESK_ERROR_MESSAGE };
    }

    inputRef.current.value = accessToken.accessToken;
    formRef.current.action = url;
    formRef.current.submit();
    return { success: true };
  } catch (error) {
    console.error('Zendesk redirect failed:', error);
    return { success: false, error: ZENDESK_ERROR_MESSAGE };
  }
};
